import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import config from '../config';
import Notification from '../components/Notification';
import LoadingSpinner from '../components/LoadingSpinner';
import '../styles/verify-password.css'; // Reuse the same CSS file
import logo from '../assets/Tr1.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone } from '@fortawesome/free-solid-svg-icons';

const ForgotPassword = () => {
    const [contactValue, setContactValue] = useState('');
    const [errors, setErrors] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [notification, setNotification] = useState({ message: '', type: 'success', header: '' });
    const [isTyping, setIsTyping] = useState(false);
    const navigate = useNavigate();

    const validateContactValue = (value) => {
        const phoneRegex = /^[0-9]{9}$/; // Validate only 9 digits for phone number
        return phoneRegex.test(value);
    };

    const handleContactValueChange = (e) => {
        const value = e.target.value;
        setContactValue(value);
        setIsTyping(true);
        if (!validateContactValue(value)) {
            setErrors({ contactValue: 'Le numéro de téléphone doit contenir 9 chiffres' });
        } else {
            setErrors({});
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateContactValue(contactValue)) {
            setErrors({ contactValue: 'Le numéro de téléphone doit contenir 9 chiffres' });
            return;
        }

        setIsSubmitting(true);
        try {
            // Use the SMS-enabled password reset endpoint
            const response = await axios.post(`${config.backendUrl}/users/request-password-reset/`, {
                contact_method: 'sms',
                contact_value: `+243${contactValue}`,
            });

            if (response.status === 200) {
                const { user_id } = response.data;
                
                setNotification({
                    message: 'Code de vérification envoyé par SMS! Redirection vers la vérification...',
                    type: 'success',
                    header: 'Succès'
                });
                
                // Redirect to SMS verification page
                setTimeout(() => {
                    navigate(`/verify-password/${user_id}`);
                }, 1500);
            }
        } catch (error) {
            if (axios.isAxiosError(error) && error.response) {
                const { status, data } = error.response;

                if (status === 400) {
                    // Handle validation errors from the SMS endpoint
                    const errorMessage = data.non_field_errors 
                        ? data.non_field_errors[0] 
                        : data.contact_value 
                        ? data.contact_value[0]
                        : 'Données invalides. Veuillez vérifier votre numéro de téléphone.';
                    
                    setNotification({
                        message: errorMessage,
                        type: 'error',
                        header: 'Erreur'
                    });
                } else if (status === 500) {
                    setNotification({
                        message: 'Échec de l\'envoi du SMS. Veuillez réessayer.',
                        type: 'error',
                        header: 'Erreur'
                    });
                } else {
                    setNotification({
                        message: 'Une erreur est survenue. Veuillez réessayer.',
                        type: 'error',
                        header: 'Erreur'
                    });
                }
            } else {
                setNotification({
                    message: 'Une erreur est survenue. Veuillez réessayer.',
                    type: 'error',
                    header: 'Erreur'
                });
            }
        } finally {
            setIsSubmitting(false);
        }
    };
    return (
        <div className="modern-auth-page" style={{ background: 'linear-gradient(135deg, #f8faff 0%, #e8f2ff 100%)' }}>
            <Notification
                message={notification.message}
                type={notification.type}
                header={notification.header}
                onClose={() => setNotification({ message: '', type: 'success', header: '' })}
            />
            <div className="verify-card">
                <div className="forgot-password-subtitle">
                    <img src={logo} alt="Logo" className="form-logo" />
                </div>
                <h2 className="verify-title">Réinitialiser le mot de passe</h2>
                <p className="verify-instructions">
                    Entrez votre numéro de téléphone. Un code de vérification vous sera envoyé par SMS.
                </p>
                <form className="verify-form" onSubmit={handleSubmit}>
                    <div className="forgot-inputs">
                        <div className={`forgot-input-container ${isTyping && errors.contactValue ? 'forgot-input-error' : ''} ${!errors.contactValue && contactValue ? 'forgot-input-valid' : ''}`}>
                            <FontAwesomeIcon
                                icon={faPhone}
                                className={`forgot-icon ${errors.contactValue ? 'forgot-icon-error' : ''} ${!errors.contactValue && contactValue ? 'forgot-icon-valid' : ''}`}
                            />
                            <span className="forgot-country-code">+243</span>
                            <input
                                type="text"
                                name="contactValue"
                                placeholder="Numéro de téléphone"
                                value={contactValue}
                                onChange={handleContactValueChange}
                                maxLength={9}
                                required
                                className="forgot-input"
                            />
                        </div>
                        {errors.contactValue && <p className="forgot-error-message">{errors.contactValue}</p>}
                    </div>
                    <button
                        type="submit"
                        className={`verify-submit ${isSubmitting || !validateContactValue(contactValue) ? 'button-disabled' : ''}`}
                        disabled={isSubmitting || !validateContactValue(contactValue)}
                    >
                        {isSubmitting ? 'Recherche en cours...' : 'Continuer'}
                    </button>
                </form>
                
                {/* Back Button */}
                <div style={{ marginTop: '24px', textAlign: 'center' }}>
                    <a 
                        href="/login" 
                        style={{ 
                            color: '#003366', 
                            textDecoration: 'none', 
                            fontSize: '14px', 
                            fontWeight: '500' 
                        }}
                    >
                        ← Retour
                    </a>
                </div>
                
                {isSubmitting && (
                    <div className="modal-background">
                        <div className="modal-content">
                            <LoadingSpinner />
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ForgotPassword;